import type { SurveyPage } from '../../../fetchSurvey/types';
import type { LogicContext } from '../../../surveyLogic/types';
import { shouldIncludePageInPath } from '../../../surveyLogic/visibility';
import type { SurveyPaginationRefs } from '../../types';

/** Mark every page between from and to as skipped (used for skip-logic jumps). */
export function markSkippedPages(
  refs: SurveyPaginationRefs,
  fromPageIndex: number,
  toPageIndex: number
): void {
  for (let pageIndex = fromPageIndex + 1; pageIndex < toPageIndex; pageIndex += 1) {
    refs.skippedPageIndices.add(pageIndex);
    refs.visitedPageIndices.delete(pageIndex);
  }
}

/** Mark only display-hidden pages between from and to as skipped. */
export function markDisplayHiddenPagesSkipped(
  refs: SurveyPaginationRefs,
  pages: SurveyPage[],
  fromPageIndex: number,
  toPageIndex: number,
  logicContext: LogicContext
): void {
  for (let pageIndex = fromPageIndex + 1; pageIndex < toPageIndex; pageIndex += 1) {
    const questions = pages[pageIndex]?.questions ?? [];
    if (!shouldIncludePageInPath(questions, logicContext)) {
      refs.skippedPageIndices.add(pageIndex);
      refs.visitedPageIndices.delete(pageIndex);
    }
  }
}

/** Mark every page after the current page through the end of the survey. */
export function markAllPagesAfterCurrentSkipped(
  refs: SurveyPaginationRefs,
  currentPageIndex: number,
  pageCount: number
): void {
  for (let pageIndex = currentPageIndex + 1; pageIndex < pageCount; pageIndex += 1) {
    refs.skippedPageIndices.add(pageIndex);
    refs.visitedPageIndices.delete(pageIndex);
  }
}
